require("datetimepick/jquery.datetimepicker.css")

let moment: any = require("moment")

import { Component, Input, AfterViewInit, ElementRef, Self }  from '@angular/core';
import { ControlValueAccessor, NgModel, NgControl } from '@angular/forms';


export abstract class AbstractDateTimePicker implements ControlValueAccessor, AfterViewInit {
	private internalDate: string;
	private datepicker: any;
	private controlValueAccessorChanged = (_) => { };
	private controlValueAccessorTouched = () => { };

	constructor(private ngControl: NgControl, private elementRef: ElementRef) {
		ngControl.valueAccessor = this;
	}

	public inputFieldChanged(dateString: string) {
		this.internalDate = dateString;
		this.updateControlValueAccessor(dateString);
	}

	public datePickerChanged = (datePickerDate: Date) => {
		let displayString: string = moment(datePickerDate).format(this.getDisplayDateFormat())
		this.updateControlValueAccessor(displayString)
	}

	abstract getDisplayDateFormat(): string;
	abstract getBackendDateFormat(): string;
	abstract getDatePickerFormat(): string;
	abstract getShowTimepicker(): boolean;
	abstract getShowDatepicker(): boolean;
	abstract getInternalDateFormatFrom(): string;
	abstract getInternalDateFormatTo(): string;
	abstract getDatePickerMinDate(): any;
	abstract getDayOfWeekStart(): number;

	private updateControlValueAccessor(dateString: string) {
		this.controlValueAccessorTouched();
		if (!dateString) {
			this.controlValueAccessorChanged("");
			return;
		}
		let outputDate = this.convertDisplayDateToBackendDate(dateString);
		if (outputDate) {
			this.controlValueAccessorChanged(outputDate);
		}
	}

	private convertDisplayDateToBackendDate(displayDate: string): string {
		let dateMomentJs: any = moment(displayDate, this.getDisplayDateFormat());
		if (!dateMomentJs.isValid()) {
			return null;
		}
		return dateMomentJs.format(this.getBackendDateFormat())
	}

	ngAfterViewInit() {
		this.datepicker = jQuery(this.elementRef.nativeElement).find("input").datetimepicker(
			{
				format: this.getDatePickerFormat(),
				step: 5,
				lang: 'de',
				todayButton: false,
				minDate: this.getDatePickerMinDate(),
				onChangeDateTime: this.datePickerChanged,
				timepicker: this.getShowTimepicker(),
				datepicker: this.getShowDatepicker(),
				dayOfWeekStart: this.getDayOfWeekStart(),
				scrollInput : false
			}
		);
	}

	writeValue(obj: any): void {
		if (obj) {
			this.internalDate = moment(obj, this.getInternalDateFormatFrom()).format(this.getInternalDateFormatTo())
		} else {
			this.internalDate = ""
			jQuery(this.elementRef.nativeElement).find("input")[0].value = ""
		}
	}

	registerOnChange(fn: any): void {
		this.controlValueAccessorChanged = fn;
	}

	registerOnTouched(fn: any): void {
		this.controlValueAccessorTouched = fn;
	}

}



// WEBPACK FOOTER //
// ./src/app/ui-helper/date-time-picker/date-time-picker.ts